import HeroImage from 'content/components/HeroImage'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Spacing from 'components/Common/Spacing'
import DesktopSearch from 'home/components/SearchHero/DesktopSearch'
import MobileSearch from 'home/components/SearchHero/MobileSearch'

const HeroContainer = styled(HeroImage)`
  ${mediaQueryDown.mobile} {
    padding: ${rem(30)} ${rem(12)};
  }

  ${mediaQueryUp.desktop} {
    padding-top: ${rem(98)};
  }
`

const HeroContent = styled(LayoutContainer)`
  position: relative;
`

const HeroDimmedOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  pointer-events: none;
`

const GlobalDesktopSearchContainer = styled.div`
  display: none;

  ${mediaQueryUp.tablet} {
    display: unset;
  }

  ${mediaQueryUp.desktop} {
    position: relative;
    top: ${rem(80)};
  }
`

const GlobalMobileSearchContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.neutral.default.eight};
  padding: ${rem(12)};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const Title = styled(Heading)`
  text-align: left;

  ${mediaQueryUp.desktop} {
    text-align: center;
  }
`

const Description = styled(BodyText)`
  text-align: left;

  ${mediaQueryUp.desktop} {
    text-align: center;
  }
`

function SearchHero({
  heroImage,
  heroImageTitle,
  heroImageSubtitle,
}: App.ContentfulHeroImage) {
  const hasContent = heroImageTitle && heroImageSubtitle && heroImage.id

  return (
    <>
      {hasContent &&
        <HeroContainer
          alt={heroImageTitle}
          fit="center"
          gravity="auto"
          id={heroImage.id!}
          mobileAspectRatio="8:9"
          tabletAspectRatio="10:3"
        >
          <HeroDimmedOverlay aria-hidden="true" role="presentation" />
          <HeroContent>
            <Title colour="neutral-eight" variant="heading1" className="hero-heading">
              {heroImageTitle}
            </Title>
            <Spacing mt={20} />
            <Description colour="neutral-eight" variant="large">{heroImageSubtitle}</Description>
            <Spacing mt={20} />

            <GlobalMobileSearchContainer>
              <MobileSearch />
            </GlobalMobileSearchContainer>

            <GlobalDesktopSearchContainer>
              <DesktopSearch />
            </GlobalDesktopSearchContainer>
          </HeroContent>
        </HeroContainer>
      }
    </>
  )
}

export default SearchHero
